import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const MaintenanceMessage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleAcknowledge = () => {
        navigate('/', { replace: true });
    };

    return (
        <>
            {/* Full page blocking background */}
            <div className="fixed inset-0 bg-white dark:bg-black z-40" />

            {/* Modal overlay */}
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-white dark:bg-slate-800 rounded-lg p-6 max-w-md w-full shadow-xl">
                    <h2 className="text-2xl font-bold mb-4 dark:text-white">
                        {t('maintenance.comingSoon')}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 mb-4">
                        {t('maintenance.message')}
                    </p>
                    <button
                        onClick={handleAcknowledge}
                        className="w-full px-4 py-2 bg-gray-800 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 focus:outline-none"
                    >
                        {t('maintenance.backHome')}
                    </button>
                </div>
            </div>
        </>
    );
};

export default MaintenanceMessage; 